/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutschecking2Inputs */

const en_ticketspayoutschecking2 = /** @type {(inputs: Ticketspayoutschecking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe is still checking your details. Nothing can be paid out until then.`)
};

const de_ticketspayoutschecking2 = /** @type {(inputs: Ticketspayoutschecking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe prüft deine Angaben noch. Bis dahin kann nichts ausgezahlt werden.`)
};

/**
* | output |
* | --- |
* | "Stripe is still checking your details. Nothing can be paid out until then." |
*
* @param {Ticketspayoutschecking2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutschecking2 = /** @type {((inputs?: Ticketspayoutschecking2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutschecking2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutschecking2(inputs)
	return de_ticketspayoutschecking2(inputs)
});
export { ticketspayoutschecking2 as "ticketsPayoutsChecking" }